import { Typography } from "@mui/material";
import React from "react";
import InsighsCard from "./InsighsCard";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MarketInsightCard from "./MarketInsightCard";
import Image from "next/image";

const InsightsList = ({
  page,
  data,
  type,
  setPage,
  pagenumber,
  isNext,
  isSimilar,
  isPageHeading = false,
}) => {
  // Section label by default; only pages with no other h1 opt in to h1.
  const Heading = isPageHeading ? "h1" : "h2";
  return (
    <div className=" w-full py-10 px-4 sm:p-20 sm:px-16">
      <div className=" mb-4 sm:mb-0 flex items-center -ml-2 sm:-ml-0">
        <Image
          src="https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709289729.svg"
          width={64}
          height={72}
          className=" h-7 sm:h-14 md:h-16 relative -ml-1 mb-4 sm:mb-2"
          alt="brand-logo"
        />
        <Heading className="text-[1.8rem] md:text-[2.5rem] -ml-4 sm:-ml-0 font-mukta sm:font-light ">
          {page}
        </Heading>
      </div>
      <div
        className={`${
          isSimilar
            ? "flex overflow-x-scroll sm:overflow-auto w-full sm:grid xl:grid-cols-3 md:grid-cols-2 sm:gap-10 sm:my-4  sm:px-8 sm:py-2 md:px-14 md:py-6 sm:justify-start"
            : "grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 sm:gap-10  sm:px-8 sm:my-4 sm:py-2 md:px-14 md:py-6 w-full sm:justify-start justify-center "
        }  ${
          type == "market insights"
            ? " sm:border-t-2 sm:border-b-2 relative"
            : ""
        }`}
      >
        {type == "market insights" ? (
          <>
            {data?.map((e, i) => {
              return (
                <>
                  <div
                    className={`border-b-2 sm:border-b-0  ${
                      i === 2 || i === 5 ? "" : "sm:border-r-2"
                    }`}
                  >
                    <MarketInsightCard data={e} type={type} />
                  </div>
                </>
              );
            })}
          </>
        ) : (
          <>
            {data?.map((e, index) => {
              return (
                <div
                  className={`${isSimilar ? "min-w-[80vw] sm:min-w-full" : ""}`}
                  key={index}
                >
                  <InsighsCard data={e} type={type} />
                </div>
              );
            })}
          </>
        )}
      </div>

      {!isSimilar && (
        <div className="w-full flex justify-end gap-4">
          <ArrowBackIcon
            className={` ${
              pagenumber > 1 ? "text-red cursor-pointer" : "text-[#ef42368a]"
            }`}
            onClick={() => {
              if (pagenumber > 1) {
                setPage(pagenumber - 1);
              }
            }}
          />
          <div
            onClick={() => {
              if (isNext) {
                setPage(pagenumber + 1);
              }
            }}
          >
            <ArrowForwardIcon
              className={`mb-1 ${
                isNext ? "text-red cursor-pointer" : "text-[#ef42368a]"
              }`}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default InsightsList;
